import { ApiCore } from '@/services/api/utils/core.js'
import { handleError, handleResponse } from '@/services/api/utils/response.js'
import axios from 'axios'
import { apiProvider } from '@/services/api/utils/provider.js'

const url = 'logout'
const plural = 'logouts'
const single = 'logout'

const api = new ApiCore({
	index: true,
	findOne: false,
	create: true,
	update: false,
	remove: false,
	url: url,
	plural: plural,
	single: single
})

api.massUpdate = () => {
	// Custom API Logic
}


export default api
